import { render, staticRenderFns } from "./matching-list-desktop.vue?vue&type=template&id=6255fad6&scoped=true&"
import script from "./matching-list-desktop.vue?vue&type=script&lang=ts&"
export * from "./matching-list-desktop.vue?vue&type=script&lang=ts&"
import style0 from "./matching-list-desktop.vue?vue&type=style&index=0&id=6255fad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6255fad6",
  null
  
)

export default component.exports